import { getWindow } from 'src/utilities/window';

export const openUrlInNewTab = (url: string): void => {
  getWindow().open(url, '_blank', 'noopener,noreferrer');
};
